import type { ControlType } from "./AnalyticsProvider";
import {
  type Action,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseHomepageExtras = {
  id: string;
  gameId?: string;
  gameName?: string;
  questId?: string;
  questType?: string;
  displayOrder?: number;
};

type HomepagePressedEvent = {
  action: Action.PRESSED;
  extras: BaseHomepageExtras & {
    control: string;
    controlType: ControlType;
    filterValue?: string;
    filterAction?: string;
  };
};

type HomepageViewedEvent = {
  action: Action.VIEWED;
  extras: BaseHomepageExtras;
};

type HomepageSucceededEvent = {
  action: Action.SUCCEEDED;
  extras: BaseHomepageExtras;
};

type HomepageFailedEvent = {
  action: Action.FAILED;
  extras: BaseHomepageExtras;
};

export type HomepageEvent =
  | HomepageViewedEvent
  | HomepagePressedEvent
  | HomepageSucceededEvent
  | HomepageFailedEvent;

export const useHomepageAnalytics = () =>
  useAnalyticsTracker<HomepageEvent>(TrackObject.HOMEPAGE);
